import { observable, action, observe } from 'mobx';
import { isDataExist } from 'Utils/dataTools';
import { message } from 'antd';
import * as services from '../services/inspect';

class SPCAnalyze {
	@observable isLoading = false;
	@observable cateList = [];
	@observable inspectList = [];
  @observable searchOptions = {};
  @observable chartType = 0
	@observable areaList = {}	
	@action.bound async getCateList() {
		try {
			let res = await services.getRequest(services.requestUrl.getCate,);
			if (isDataExist(res)) {
        let list = []
        for(let key in res.data.data){
          list.push({
            cateCode:key,
            cateName:res.data.data[key]
          })
        }
				this.cateList = list;
			}
		} catch (error) {
			console.log(error);
		}
	}
	@action.bound async getInspectRules(type,params) {
		try {
      let req = type ? 'getProcedureList' : 'getInspectRules'
			let res = await services.getRequest(services.requestUrl[req],params)
			if (isDataExist(res)) {
				this.inspectList = res.data.data
			}
		} catch (error) {
			console.log(error);
		}
  }
  // 获取计量型分析图型
	@action.bound async getAreaData(type,params) {
    this.isLoading = true;
    this.chartType = params.chartType
		try {
      let req = type ? 'getMeasureData' : 'getNumberData'
      let res = await services.getRequest(services.requestUrl[req],params)
			this.isLoading = false;
			if (isDataExist(res)) {
				this.areaList = res.data.data;
			}
		} catch (error) {
			console.log(error);
		}
	}
	//所有设备类型
	@action.bound async getAllDeviceType(params) {
		this.isLoading = true;
		try {
			let res = await services.getRequest(
				services.requestUrl.getDeviceType,
				params
			);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.devTypeList = [];
				res.data.data.map(item => {
					this.devTypeList.push({
						label: item.modelName,
						value: item.id.toString()
					});
				});
			}
		} catch (error) {
			console.log(error);
		}
	}
	//所有工单
	@action.bound async getAllOdd(params) {
		this.isLoading = true;
		try {
			let res = await services.getRequest(
				services.requestUrl.getAllOdd,
				params
			);
			this.isLoading = false;
			if (isDataExist(res)) {
				this.oddList = res.data.data;
			}
		} catch (error) {
			console.log(error);
		}
	}

	//打开/关闭模态框
	@action modalChange = (type, record) => {
		if (type) {
			this.formData = record;
		} else {
			this.formData = {};
		}
		this.modalType = type;
		this.modalVisible = !this.modalVisible;
	};
	//打开/关闭模态框
	@action clearData = () => {
		this.isLoading = false;
		this.cateList = [];
		this.inspectList = [];
		this.searchOptions = {};
		this.chartType = 0
		this.areaList = {}	
	};
}

let SPCAnalyzeStore = new SPCAnalyze();
export default SPCAnalyzeStore;
